import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { FieldPath } from 'react-hook-form';
import { ICompanyDataModel } from '../../../data-models/company.data-model';
import { CompanyDetailsPanel, FieldsPerPage } from '../../CompanyProfiles2/Summary/CompanyDetailsPanel';
import { useAllCompanyDetailsFields } from '../../CompanyProfiles2/Summary/useCompanyDetailsFields';
import { useShowSummaryV2 } from '../../CompanyProfiles2/Summary/useShowSummaryV2';
import { useLoadSelectedDetailsFields } from './data-display-utils';
import { selectedDetailsFieldsOrgState } from './DataDisplayState';
import { DisplayConfig, IDummySectionProps } from './DisplayConfig';
import { DummyCompanyId } from './DummyData';
import { useDetailsConfigActions } from './useDataDisplayConfigActions';

export function CompanyDetailsConfig() {
  // With `showSummaryV2` the profile's Company Details card no longer paginates — it shows one group
  // of fields and puts the rest behind "Show All" — so page numbers here would configure something
  // the user never sees. Label the groups by visibility instead.
  const showSummaryV2 = useShowSummaryV2();
  const { loaded } = useLoadSelectedDetailsFields();
  const allFields = useAllCompanyDetailsFields();
  const [selectedFields, setSelectedFields] = useAtom(selectedDetailsFieldsOrgState);
  const { handleSave, handleReset } = useDetailsConfigActions();

  const renderDummySection = useCallback(
    ({ defaultPage, key }: IDummySectionProps) => {
      return (
        <CompanyDetailsPanel
          companyId={DummyCompanyId}
          editable={false}
          fieldsToShow={selectedFields as FieldPath<ICompanyDataModel>[]}
          key={key}
          defaultPage={defaultPage}
        />
      );
    },
    [selectedFields]
  );

  if (!loaded) {
    return null;
  }
  return (
    <DisplayConfig
      title='Company Details Section'
      allFields={allFields}
      selectedFields={selectedFields}
      setSelectedFields={setSelectedFields}
      handleResetConfig={handleReset}
      handleSaveChanges={handleSave}
      fieldsPerPage={FieldsPerPage}
      renderDummySection={renderDummySection}
      groupLabelMode={showSummaryV2 ? 'visibility' : 'pages'}
    />
  );
}
